import React, { useEffect, useRef, useState } from 'react'
import { Button, Tooltip } from 'antd'
import { FaPlus } from 'react-icons/fa'
import styles from './CreateAction.module.scss'

// Round "+" create button. When it scrolls out of view, a floating copy appears in the bottom-right corner.
function CreateAction({ label, onClick, className }) {
  const anchorRef = useRef(null)
  const [floating, setFloating] = useState(false)

  useEffect(() => {
    const target = anchorRef.current
    if (!target) return
    // Top margin = sticky header height ($header-height), so a button hidden under it counts as gone
    const observer = new IntersectionObserver(
      ([entry]) => setFloating(!entry.isIntersecting),
      { rootMargin: '-56px 0px 0px 0px' }
    )
    observer.observe(target)
    return () => observer.disconnect()
  }, [])

  const renderButton = (buttonClassName) => (
    <Tooltip title={label} placement="left">
      <Button
        type="primary"
        shape="circle"
        size="large"
        className={buttonClassName}
        icon={<FaPlus />}
        aria-label={label}
        onClick={onClick}
      />
    </Tooltip>
  )

  return (
    <>
      <div ref={anchorRef} className={className}>
        {renderButton()}
      </div>
      {floating && renderButton(styles.fab)}
    </>
  )
}

export default CreateAction
